export default __webpack_public_path__ + "static/media/blogDetail2.96b910fa.png";